import styled, { css } from "styled-components";
import { ButtonFontSize, ButtonSize, ButtonVariant, buttonStyling } from "../button/Shared";
import { iconName } from "../icons/Icons";

function getButtonIconSize(size:ButtonSize):string
{
    switch(size)
    {
        case "22px": return "12px";
        case "32px": return "16px"; //default
        case "42px": return "21px";
        case "52px": return "26px";
        default: return "21px";
    }
}

function getButtonFontSize(size:ButtonSize):string
{
    switch(size)
    {
        case "22px": return "12px";
        case "32px": return "16px"; //default
        case "42px": return "16px";
        case "52px": return "26px";
        default: return "16px";
    }
}

export const Styled2Button = css<{ 
    disabled?:boolean,
    emphasize?:boolean,
    fontSize?: ButtonFontSize,
    size?: ButtonSize,
    variant: ButtonVariant,
    icon?:iconName,
    iconPosition?:string,
    hasText?:boolean,
}>`
    align-items: center;
    background: ${props => buttonStyling(props.theme.colors).handleButtonBackground(props.variant)};
    border: ${props => buttonStyling(props.theme.colors).handleButtonBorder(props.variant)};
    border-radius: 4px;
    color: ${props => buttonStyling(props.theme.colors).handleButtonColor(props.variant)};
    display:inline-flex;
    flex-direction: ${props => props.iconPosition === "right" ? "row-reverse" : "row"};
    font-size: ${props => props.fontSize ? props.fontSize : getButtonFontSize(props.size ? props.size : "32px")};
    font-family: "Noto Sans", sans-serif;
    font-weight: 400;
    height: ${props => props.size ? props.size : "42px"};
    justify-content: center;
    letter-spacing: 0.25px;
    min-width: ${props => props.size ? props.size : "42px"};
    padding: 0 8px;
    position: relative;
    text-decoration: none;
    transition: all 0.15s ease-out;
    white-space: nowrap;

    & span{
        padding: 0 8px;
    }

    & div{
        ${props => props.hasText
            ? (props.iconPosition === "right" ? "margin: 0 8px 0 0;" : "margin: 0 0 0 8px;")
            : ""
        }
        width: ${props => getButtonIconSize(props.size ? props.size : "42px")};
        height: ${props => getButtonIconSize(props.size ? props.size : "42px")};
    }
    

    & svg {
        display: flex;
        transition: fill 0.15s ease-out;
        fill: ${props => props.emphasize ? "black" : buttonStyling(props.theme.colors).handleButtonColor(props.variant)};
        height: ${props => getButtonIconSize(props.size ? props.size : "42px")};
        width: ${props => getButtonIconSize(props.size ? props.size : "42px")};
    }

    &:hover, &:focus-visible {
        background: ${props => buttonStyling(props.theme.colors).handleButtonHoverBackground(props.variant)};
        color: ${props =>  buttonStyling(props.theme.colors).handleButtonHoverColor(props.variant)};
        border: ${props => buttonStyling(props.theme.colors).handleButtonBorder(props.variant)};
        cursor: pointer;
        & svg{
            fill: ${props => buttonStyling(props.theme.colors).handleButtonHoverColor(props.variant)};
        }
        outline:none;
    }

    &:active{
        background: ${props => buttonStyling(props.theme.colors).handleButtonBackground(props.variant)};
        color: ${props =>  buttonStyling(props.theme.colors).handleButtonColor(props.variant)};
        border: ${props => buttonStyling(props.theme.colors).handleButtonBorder(props.variant)};
    }


    ${props => {
        
        if(props.disabled){
            return css`
                background: ${buttonStyling(props.theme.colors).handleButtonBackgroundDisabled(props.variant)};
                color: ${buttonStyling(props.theme.colors).handleButtonColorDisabled(props.variant)};
                

                 & svg {
                    fill: ${buttonStyling(props.theme.colors).handleButtonColorDisabled(props.variant)};
                }

                &:hover, &:focus-visible {
                    background: ${buttonStyling(props.theme.colors).handleButtonBackgroundDisabled(props.variant)};
                    color: ${ buttonStyling(props.theme.colors).handleButtonColorDisabled(props.variant)};
                
                    cursor: not-allowed;
                    & svg{
                        fill: ${buttonStyling(props.theme.colors).handleButtonColorDisabled(props.variant)};
                    }
                }
            `;
        }
    }}
`;

export const StyledButton = styled.button<{ 
    size?: ButtonSize,
    fontSize?: ButtonFontSize,
    variant: ButtonVariant,
    icon?:iconName,
    iconPosition?:string,
    hasText?:boolean,
    disabled?:boolean,
    titleText?:string,
    emphasize?:boolean,
}>`
    ${Styled2Button}
`;


export const IconWrapper = styled.div<{ variant: ButtonVariant, disabled?:boolean, size?: ButtonSize, emphasize?:boolean}>`
    
    height: ${props => getButtonIconSize(props.size ? props.size : "42px")};
    width: ${props => getButtonIconSize(props.size ? props.size : "42px")};
    z-index: 101;

    & svg {
        height: 100%;
        width: 100%;
        fill: ${props => props.disabled
            ? buttonStyling(props.theme.colors).handleButtonColorDisabled(props.variant)
            : props.emphasize ? "black" : buttonStyling(props.theme.colors).handleButtonColor(props.variant)};
        
    }
`;